import { Stack, Typography, useTheme } from '@mui/material';

export default function ErrorBox({ icon, text }) {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			spacing={1}
			sx={{
				backgroundColor: theme.palette.root.errorBackground,
				padding: '15px',
				borderRadius: '8px',
				display: 'flex',
				alignItems: 'center',
			}}
		>
			{icon}
			<Typography variant="body5">{text}</Typography>
		</Stack>
	);
}
